module.exports = __webpack_public_path__ + "img/energetyka-24.fb936884.svg";